import store from '@/store'
import minimatch from 'minimatch'

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value) {
  console.log(value)
  if (value && value instanceof Array && value.length > 0) {
    const roles = store.getters && store.getters.roles
    const permissionRoles = value

    const hasPermission = roles.some(role => {
      return permissionRoles.includes(role)
    })
    return hasPermission
  } else {
    // console.error(`need roles! Like v-permission="['admin','editor']"`)
    return false
  }
}

export function checkPermissionRule(permissionList, permission) {
  const roles = store.getters.roles
  if (typeof roles === 'object' && roles.indexOf('admin') >= 0) {
    return true
  }
  for (const p of permissionList) {
    if (p === permission) {
      return true
    }
    if (p.indexOf('*') >= 0 && minimatch(permission, p)) {
      return true
    }
  }
  return false
}
